import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=2a999909"
import script from "./ChatThread.vue?vue&type=script&lang=js"
export * from "./ChatThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports